import noUiSlider from 'nouislider';

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.js_filter_slider').forEach(function(slider) {
    noUiSlider.create(slider, {
      start: [slider.dataset.startMin, slider.dataset.startMax],
      connect: true,
      range: {
        'min': parseFloat(slider.dataset.min),
        'max': parseFloat(slider.dataset.max)
      },
      step: parseInt(slider.dataset.allowFloat) ? 0.1 : 1,
    });

    const sliderInputWrapper = document.querySelector('[data-slider="' + slider.id +'"]');
    if (!sliderInputWrapper) {
      return;
    }

    const minInput = sliderInputWrapper.querySelector('.js_slider_value_min');
    const maxInput = sliderInputWrapper.querySelector('.js_slider_value_max');

    // Update slider when input fields change
    minInput.addEventListener('blur', function() {
      slider.noUiSlider.set([this.value, maxInput.value]);
    });
    maxInput.addEventListener('blur', function() {
      slider.noUiSlider.set([minInput.value, this.value]);
    });

    // Unfortunately, binding the update event also triggers it immediately. This is a workaround to prevent a reload
    // of the search results when the slider is initially created.
    window.preventSearchResultReload = true;
    // Update input fields when slider changes
    slider.noUiSlider.on('update', function() {
      setInputValues(slider, minInput, maxInput);
    });
    window.preventSearchResultReload = false;
  });
});

function setInputValues(slider, minInput, maxInput) {
  let [minValue, maxValue] = slider.noUiSlider.get();
  let minChanged, maxChanged;
  if (parseInt(slider.dataset.allowFloat)) {
    minValue = Math.round(minValue * 10) / 10;
    maxValue = Math.round(maxValue * 10) / 10;
    [minChanged, maxChanged] = [minValue !== parseFloat(minInput.value), maxValue !== parseFloat(maxInput.value)];
  } else {
    minValue = Math.round(minValue);
    maxValue = Math.round(maxValue);
    [minChanged, maxChanged] = [minValue !== parseInt(minInput.value), maxValue !== parseInt(maxInput.value)];
  }

  if (minChanged) {
    minInput.value = minValue;
  }
  if (maxChanged) {
    maxInput.value = maxValue;
  }
  updateRangeResult(slider);
}

function updateRangeResult(slider) {
  let [minValue, maxValue] = slider.noUiSlider.get();
  const rangeResult = document.querySelector('.js_range_result[data-slider="' + slider.id + '"]');
  minValue *= rangeResult.dataset.multiplier;
  maxValue *= rangeResult.dataset.multiplier;
  if (parseInt(slider.dataset.allowFloat)) {
    minValue = Math.round(minValue * 10) / 10;
    maxValue = Math.round(maxValue * 10) / 10;
  } else {
    minValue = Math.round(minValue);
    maxValue = Math.round(maxValue);
  }
  rangeResult.value = minValue + '-' + maxValue;
  rangeResult.dispatchEvent(new Event('change'));
}